import React from 'react';
import './BusinessAppDownload.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAndroid } from '@fortawesome/free-brands-svg-icons';
import { faAppleAlt } from '@fortawesome/free-solid-svg-icons';

const BusinessAppDownload = () => {
    return (
        <section className="business-app-download-section" style={{background: `url('/img/app-download.webp')`}}>
            <div className="top-angle-bg" style={{background: `url('/img/top-side.svg')`}}></div>
                <div className="app-download-content">
                    <div className="container">
                        <div className="app-download-main-content">
                            <div className="app-download-content-left">
                                <h2 className="heading">Elite Partyz app is available on Android & iPhone</h2>
                                <p className="description">Download the app today and create your business profile.</p>
                                <div className="download-btn-group">
                                <a href="https://play.google.com/store/apps/details?id=com.app.partyzsupplier" className="download-btn"><FontAwesomeIcon icon={faAndroid} /></a>
                                    <a href="https://apps.apple.com/us/app/elite-partyz-business/id1484040597?ls=1" className="download-btn"><FontAwesomeIcon icon={faAppleAlt} /></a>
                                </div>
                            </div>
                            <div className="app-download-content-right">
                                <img src="/img/b-event.webp" alt="Download Business app" />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="bottom-angle-bg" style={{background: `url('/img/bottom-side.svg')`}}></div>
        </section>
    )
}

export default BusinessAppDownload
